import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Locality } from 'src/app/core/models';

@Component({
  selector: 'app-modal-estimation-bien',
  templateUrl: './modal-estimation-bien.component.html',
  styleUrls: ['./modal-estimation-bien.component.scss'],
})
export class ModalEstimationBienComponent implements OnInit, OnChanges {
  closeResult?: string;
  @Input() locality: any = {};
  @Input() requiredLocality: boolean = false;
  @Input() hideBtnOpen: boolean = false;
  @Input() externalOpen: boolean = false;
  @Output() tryOpen: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('contentEstimation') modalContentEstimation: any;
  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    if(this.externalOpen){
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.modalService.open(this.modalContentEstimation, { centered: true, size: 'xl' });
    }  
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.externalOpen){
      if (!changes.externalOpen.previousValue && changes.externalOpen.currentValue) {
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
        this.modalService.open(this.modalContentEstimation, { centered: true, size: 'xl' });
      }
    }
  }

  openVerticallyCentered(content: any) {
    this.emitSubmit();
    if(!this.requiredLocality || this.locality?.ville){
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.modalService.open(content, { centered: true, size: 'xl' });
    }
  }

  emitSubmit(){
    this.tryOpen.emit(1)
  }

  accessToTool(){
    let ville = this.locality?.ville ? this.locality?.ville : ''
    let URL = `https://online.jestimo.com//?bien_rue=${encodeURIComponent(ville)}&agenceId=1379&__checkbox_conditions=true`
    window.open(URL, "_blank", "noopener,noreferrer");
  }

}
